import { useEffect } from 'react';
import { useAction } from 'hooks';
import App from 'modules/App';
import { SIGN_UP_FORM } from '../../../../constants';
import { useIsMinor } from '../hooks';
const useGuardianConsentsEmailEffects = ()=>{
    const isMinor = useIsMinor();
    const unsetFormValues = useAction(App.actions.unsetFormValues, SIGN_UP_FORM);
    useEffect(()=>{
        if (!isMinor) {
            unsetFormValues('guardianEmail');
        }
    }, [
        isMinor
    ]);
};
export default useGuardianConsentsEmailEffects;
